<h2 mat-dialog-title class="bgDialogHeader text-center">Update Meter Readings
  <div class="pull-right">
    <a class="boxclose" (click)="onNoClick()"></a>
  </div>
</h2>
<mat-dialog-content class="mat-typography">
  <div class="meterDetaisDiv">
    <div class="row">
      <div class="col-12 mt-2">
        <mat-form-field>
          <input matInput [matDatepicker]="picker1" (focus)="picker1.open()" placeholder="Date (YYYY-MM-DD)">
          <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
          <mat-datepicker #picker1></mat-datepicker>
        </mat-form-field>
      </div>
      <div class="col-12 col-sm-6 mt-2">
        <mat-form-field>
          <input type="text" matInput placeholder="Hours">
        </mat-form-field>
      </div>
      <div class="col-12 col-sm-6 mt-2">
        <mat-form-field>
          <input type="text" matInput placeholder="Mileage">
        </mat-form-field>
      </div>
      <div class="col-12 mt-2 table-scroll">
        <mat-checkbox class="mt-3">Update Last Validated Meter Reading</mat-checkbox>
      </div>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-dialog-close class="btn btn-semi-round bgBlue pull-right m-1"> Save </button>
  <button mat-dialog-close class="btn btn-semi-round bgBlue pull-right m-1"> Cancel </button>
</mat-dialog-actions>
